import uberAdminEmails from "../data/uber-admin-emails";

const credentials = JSON.parse(localStorage.getItem("credentials"));

const isUberAdmin =
  credentials &&
  credentials.user &&
  credentials.user.isAdmin &&
  credentials.user.email in uberAdminEmails;

export default isUberAdmin;



// WEBPACK FOOTER //
// ./src/utils/is-uber-admin.js